import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, Star } from 'lucide-react';
export function PackContent() {
  const cards = [{
    tag: 'PDF · 6 tomos',
    title: 'MegaPack Nutri Infantil Lista',
    desc: 'Biblioteca práctica para evaluar, intervenir y ordenar consulta infantil.',
    bullets: ['Evaluación infantil sin bloqueo', 'Selectividad alimentaria', 'Hábitos, rutinas y ambiente alimentario', 'Intervención práctica', 'Sostén entre consultas', 'Consulta más clara y aplicable'],
    premium: false
  }, {
    tag: 'PDF imprimible',
    title: 'Láminas Pro de Alimentación Infantil',
    desc: 'Pack visual con imágenes de alimentos, grupos alimentarios y comidas para mostrarle al niño qué comer.',
    bullets: ['Frutas, verduras, proteínas, lácteos y carbohidratos', 'Ejemplos de desayuno, almuerzo, merienda, cena y colaciones', 'Material listo para imprimir y entregar', 'Uso directo en consultorio'],
    premium: true
  }];
  return <section className="py-16 md:py-24 px-4 bg-black" data-id="element-189">
      <div className="max-w-5xl mx-auto" data-id="element-190">
        <FadeIn className="text-center mb-16" data-id="element-191">
          <span className="text-terracotta text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-192">
            El contenido del pack
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-6" data-id="element-193">
            ¿Qué hay dentro del MegaPack?
          </h2>
          <p className="text-lg text-cream/70 max-w-2xl mx-auto" data-id="element-194">
            Herramientas digitales listas para usar, pensadas para consulta
            infantil real y para elevar el valor de tu trabajo profesional.
          </p>
        </FadeIn>

        <div className="space-y-8 mb-16" data-id="element-195">
          {cards.map((card, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-196">
              <div className={(card.premium ? 'glow-beige-pulse' : 'glow-beige') + ' bg-black rounded-3xl p-8 md:p-10 relative overflow-hidden'} data-id="element-197">
                <div className="relative z-10" data-id="element-198">
                  <div className="flex flex-wrap items-center gap-2 mb-6" data-id="element-199">
                    <span className="inline-block bg-sand/15 border border-sand/30 text-sand text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-widest" data-id="element-200">
                      {card.tag}
                    </span>
                    {card.premium && <span className="inline-flex items-center gap-1.5 bg-terracotta/15 border border-terracotta/40 text-terracotta text-[10px] md:text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-widest" data-id="element-201">
                        <Star size={11} className="fill-current" data-id="element-202" />
                        Solo en Pack Completo
                      </span>}
                  </div>

                  <div className="grid md:grid-cols-5 gap-8 items-start" data-id="element-203">
                    <div className="md:col-span-2" data-id="element-204">
                      <h3 className="font-display text-2xl md:text-3xl font-bold text-cream mb-4" data-id="element-205">
                        {card.title}
                      </h3>
                      <p className="text-cream/70 font-medium leading-relaxed" data-id="element-206">
                        {card.desc}
                      </p>
                    </div>

                    <div className="md:col-span-3 glow-beige bg-black rounded-2xl p-6" data-id="element-207">
                      <ul className="grid sm:grid-cols-2 gap-4" data-id="element-208">
                        {card.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-3" data-id="element-209">
                            <Check size={18} className="text-sand shrink-0 mt-0.5" data-id="element-210" />
                            <span className="text-cream/80 text-sm font-medium leading-relaxed" data-id="element-211">
                              {bullet}
                            </span>
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="text-center" data-id="element-212">
          <p className="text-cream/50 text-sm font-bold tracking-widest uppercase" data-id="element-213">
            100% digital • Imprimible • Acceso inmediato
          </p>
        </FadeIn>
      </div>
    </section>;
}